
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from "../../../Redux/Slice/AxiosInstance/AxiosInstance";
import Cookies from "js-cookie";

const BaseURL = process.env.REACT_APP_API_URL;

const DataBase = Cookies.get("Database");

const firmName = Cookies.get("FinancialYear")
export const StoreFilters = createAsyncThunk("Store/StoreFilters", async (data) => {
    try {
        const response = await api.post(
            `/Store/StoreFilters`,
            {
                DataBase: DataBase,

            },

        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const InwardAnalysis = createAsyncThunk("Store/InwardAnalysis", async (data) => {
    try {
        const response = await api.post(
            `/Store/InwardAnalysis`,
            {
                FirmIDs: data.firm,
                ItemIDs: data.ItemIDs ? data.ItemIDs : "",
                ItemGrpIDs: data.ItemGrpIDs ? data.ItemGrpIDs : "",
                BookIDs: data.BookIDs ? data.BookIDs : "",
                StartDate: data.StartDate ? data.StartDate : "",
                EndDate: data.EndDate ? data.EndDate : "",
                DataBase: DataBase,

            },

        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const InwardItemWiseSumm = createAsyncThunk("Store/InwardItemWiseSumm", async (data) => {
    try {
        const response = await api.post(
            `/Store/InwardItemWiseSumm`,
            {
                FirmIDs: data.firm,
                ItemIDs: data.ItemIDs ? data.ItemIDs : "",
                ItemGrpIDs: data.ItemGrpIDs ? data.ItemGrpIDs : "",
                BookIDs: data.BookIDs ? data.BookIDs : "",
                StartDate: data.StartDate ? data.StartDate : "",
                EndDate: data.EndDate ? data.EndDate : "",
                DataBase: DataBase,

            },

        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const IssueAnalysis = createAsyncThunk("Store/IssueAnalysis", async (data) => {
    try {
        const response = await api.post(
            `/Store/IssueAnalysis`,
            {
                FirmIDs: data.firm,
                AcYearIDs: data.Acyear,
                MachineGroupMstIDs: data.MachineGroupMstIDs ? data.MachineGroupMstIDs : "",
                BookIDs: data.BookIDs ? data.BookIDs : "",
                ItemGrpIDs: data.ItemGrpIDs ? data.ItemGrpIDs : "",
                StartDate: data.StartDate ? data.StartDate : "",
                EndDate: data.EndDate ? data.EndDate : "",
                DataBase: DataBase,

            },

        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const FSNAnalysis = createAsyncThunk("Store/FSNAnalysis", async (data) => {
    try {
        const response = await api.post(
            `/Store/FSNAnalysis`,
            {
                FirmIDs: data.firm,
                IdxMonthNameIDs: data.IdxMonthNameIDs ? data.IdxMonthNameIDs : "",
                ItemIDs: data.ItemIDs ? data.ItemIDs : "",
                ItemSubGrpIDs: data.ItemSubGrpIDs ? data.ItemSubGrpIDs : "",
                BookIDs: data.BookIDs ? data.BookIDs : "",
                DataBase: DataBase,

            },

        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const ItemWiseMachineWiseCon = createAsyncThunk("Store/ItemWiseMachineWiseCon", async (data) => {
    try {
        const response = await api.post(
            `/Store/ItemWiseMachineWiseCon`,
            {
                FirmIDs: data.firm,
                AcYearIDs: data.Acyear,
                MachineGroupMstIDs: data.MachineGroupMstIDs ? data.MachineGroupMstIDs : "",
                IdxMonthNameIDs: data.IdxMonthNameIDs ? data.IdxMonthNameIDs : "",
                colType: data.colType ? data.colType : "",
                BookIDs: data.BookIDs ? data.BookIDs : "",
                StartDate: data.StartDate ? data.StartDate : "",
                EndDate: data.EndDate ? data.EndDate : "",
                DataBase: DataBase,


            },

        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const MachineWiseConSumm = createAsyncThunk("Store/MachineWiseConSumm", async (data) => {
    try {
        const response = await api.post(
            `/Store/MachineWiseConSumm`,
            {
                FirmIDs: data.firm,
                AcYearIDs: data.Acyear,
                MachineGroupMstIDs: data.MachineGroupMstIDs ? data.MachineGroupMstIDs : "",
                IdxMonthNameIDs: data.IdxMonthNameIDs ? data.IdxMonthNameIDs : "",
                BookIDs: data.BookIDs ? data.BookIDs : "",
                StartDate: data.StartDate ? data.StartDate : "",
                EndDate: data.EndDate ? data.EndDate : "",
                DataBase: DataBase,

            },

        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const MachineWiseGrpWiseCon = createAsyncThunk("Store/MachineWiseGrpWiseCon", async (data) => {
    try {
        const response = await api.post(
            `/Store/MachineWiseGrpWiseCon`,
            {
                FirmIDs: data.firm,
                AcYearIDs: data.Acyear,
                MachineGroupMstIDs: data.MachineGroupMstIDs ? data.MachineGroupMstIDs : "",
                IdxMonthNameIDs: data.IdxMonthNameIDs ? data.IdxMonthNameIDs : "",
                BookIDs: data.BookIDs ? data.BookIDs : "",
                StartDate: data.StartDate ? data.StartDate : "",
                EndDate: data.EndDate ? data.EndDate : "",
                DataBase: DataBase,

            },

        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const MachineWiseConAnalysis = createAsyncThunk("Store/MachineWiseConAnalysis", async (data) => {
    try {
        const response = await api.post(
            `/Store/MachineWiseConAnalysis`,
            {
                FirmIDs: data.firm,
                AcYearIDs: data.Acyear,
                MachineGroupMstIDs: data.MachineGroupMstIDs ? data.MachineGroupMstIDs : "",
                IdxMonthNameIDs: data.IdxMonthNameIDs ? data.IdxMonthNameIDs : "",
                BookIDs: data.BookIDs ? data.BookIDs : "",
                StartDate: data.StartDate ? data.StartDate : "",
                EndDate: data.EndDate ? data.EndDate : "",
                DataBase: DataBase,

            },

        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const ABCAnalysis = createAsyncThunk("Store/ABCAnalysis", async (data) => {
    try {
        const response = await api.post(
            `/Store/ABCAnalysis`,
            {
                FirmIDs: data.firm,
                AcYearIDs: data.Acyear,
                ItemSubGrpIDs: data.ItemSubGrpIDs ? data.ItemSubGrpIDs : "",
                IdxMonthNameIDs: data.IdxMonthNameIDs ? data.IdxMonthNameIDs : "",
                BookIDs: data.BookIDs ? data.BookIDs : "",
                ItemIDs: data.ItemIDs ? data.ItemIDs : "",
                DataBase: DataBase,


            },

        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const PartyVsItem = createAsyncThunk("Store/PartyVsItem", async (data) => {
    try {
        const response = await api.post(
            `/Store/PartyVsItem`,
            {
                FirmIDs: data.firm,
                AcYearIDs: data.Acyear,
                StartDate: data.StartDate ? data.StartDate : "",
                EndDate: data.EndDate ? data.EndDate : "",
                AcIDs: data.AcIDs ? data.AcIDs : "",
                DataBase: DataBase,

            },

        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const MachineGrpMonthlyCon = createAsyncThunk("Store/MachineGrpMonthlyCon", async (data) => {
    try {
        const response = await api.post(
            `/Store/MachineGrpMonthlyCon`,
            {
                FirmIDs: data.firm,
                AcYearIDs: data.Acyear,
                MachineGroupMstIDs: data.MachineGroupMstIDs ? data.MachineGroupMstIDs : "",
                BookIDs: data.BookIDs ? data.BookIDs : "",
                DataBase: DataBase,

            },

        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const ItemVsSupplier = createAsyncThunk("Store/ItemVsSupplier", async (data) => {
    try {
        const response = await api.post(
            `/Store/ItemVsSupplier`,
            {
                FirmIDs: data.firm,
                AcYearIDs: data.Acyear,
                ItemIDs: data.ItemIDs ? data.ItemIDs : "",
                ItemGrpIDs: data.ItemGrpIDs ? data.ItemGrpIDs : "",
                ItemSubGrpIDsIDs: data.ItemSubGrpIDsIDs ? data.ItemSubGrpIDsIDs : "",
                StartDate: data.StartDate ? data.StartDate : "",
                EndDate: data.EndDate ? data.EndDate : "",
                DataBase: DataBase,

            },

        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const StoreStockAnalysis = createAsyncThunk("Store/StoreStockAnalysis", async (data) => {
    try {
        const response = await api.post(
            `/Store/StoreStockAnalysis`,
            {
                FirmIDs: data.firm,
                ItemIDs: data.ItemIDs ? data.ItemIDs : "",
                ItemGrpIDs: data.ItemGrpIDs ? data.ItemGrpIDs : "",
                IdxMonthNameIDs: data.IdxMonthNameIDs ? data.IdxMonthNameIDs : "",
                DataBase: DataBase,

            },

        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});







export const MaintenanceSlice = createSlice({
    name: 'Store',
    initialState: {
        StoreFiltersdata: null,
        InwardAnalysisdata: null,
        InwardItemWiseSummdata: null,
        IssueAnalysisdata: null,
        FSNAnalysisdata: null,
        ItemWiseMachineWiseCondata: null,
        MachineWiseConSummdata: null,
        MachineWiseGrpWiseCondata: null,
        MachineWiseConAnalysisdata: null,
        ABCAnalysisdata: null,
        PartyVsItemdata: null,
        MachineGrpMonthlyCondata: null,
        ItemVsSupplierdata: null,
        StoreStockAnalysisdata: null,

        status: 'idle',
        error: null,
    },
    reducers: {
        StoreFiltersFun: (state) => {
            state.StoreFiltersdata = "no";
        },
        InwardAnalysisFun: (state) => {
            state.InwardAnalysisdata = "no";
        },
        InwardItemWiseSummFun: (state) => {
            state.InwardItemWiseSummdata = "no";
        },
        IssueAnalysisFun: (state) => {
            state.IssueAnalysisdata = "no";
        },
        FSNAnalysisFun: (state) => {
            state.FSNAnalysisdata = "no";
        },
        ItemWiseMachineWiseConFun: (state) => {
            state.ItemWiseMachineWiseCondata = "no";
        },
        MachineWiseConSummFun: (state) => {
            state.MachineWiseConSummdata = "no";
        },
        MachineWiseGrpWiseConFun: (state) => {
            state.MachineWiseGrpWiseCondata = "no";
        },
        MachineWiseConAnalysisFun: (state) => {
            state.MachineWiseConAnalysisdata = "no";
        },
        ABCAnalysisFun: (state) => {
            state.ABCAnalysisdata = "no";
        },
        PartyVsItemFun: (state) => {
            state.PartyVsItemdata = "no";
        },
        MachineGrpMonthlyConFun: (state) => {
            state.MachineGrpMonthlyCondata = "no";
        },
        ItemVsSupplierFun: (state) => {
            state.ItemVsSupplierdata = "no";
        },
        StoreStockAnalysisFun: (state) => {
            state.StoreStockAnalysisdata = "no";
        },




    },
    extraReducers: (builder) => {
        builder
            .addCase(StoreFilters.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(StoreFilters.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.StoreFiltersdata = action.payload;
            })
            .addCase(StoreFilters.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })



            .addCase(InwardAnalysis.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(InwardAnalysis.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.InwardAnalysisdata = action.payload;
            })
            .addCase(InwardAnalysis.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(InwardItemWiseSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(InwardItemWiseSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.InwardItemWiseSummdata = action.payload;
            })
            .addCase(InwardItemWiseSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })


            .addCase(IssueAnalysis.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(IssueAnalysis.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.IssueAnalysisdata = action.payload;
            })
            .addCase(IssueAnalysis.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })


            .addCase(FSNAnalysis.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(FSNAnalysis.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.FSNAnalysisdata = action.payload;
            })
            .addCase(FSNAnalysis.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })


            .addCase(ItemWiseMachineWiseCon.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(ItemWiseMachineWiseCon.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.ItemWiseMachineWiseCondata = action.payload;
            })
            .addCase(ItemWiseMachineWiseCon.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(MachineWiseConSumm.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(MachineWiseConSumm.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.MachineWiseConSummdata = action.payload;
            })
            .addCase(MachineWiseConSumm.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(MachineWiseGrpWiseCon.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(MachineWiseGrpWiseCon.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.MachineWiseGrpWiseCondata = action.payload;
            })
            .addCase(MachineWiseGrpWiseCon.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(MachineWiseConAnalysis.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(MachineWiseConAnalysis.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.MachineWiseConAnalysisdata = action.payload;
            })
            .addCase(MachineWiseConAnalysis.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(ABCAnalysis.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(ABCAnalysis.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.ABCAnalysisdata = action.payload;
            })
            .addCase(ABCAnalysis.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(PartyVsItem.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(PartyVsItem.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.PartyVsItemdata = action.payload;
            })
            .addCase(PartyVsItem.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })


            .addCase(MachineGrpMonthlyCon.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(MachineGrpMonthlyCon.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.MachineGrpMonthlyCondata = action.payload;
            })
            .addCase(MachineGrpMonthlyCon.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            .addCase(ItemVsSupplier.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(ItemVsSupplier.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.ItemVsSupplierdata = action.payload;
            })
            .addCase(ItemVsSupplier.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })


            .addCase(StoreStockAnalysis.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(StoreStockAnalysis.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.StoreStockAnalysisdata = action.payload;
            })
            .addCase(StoreStockAnalysis.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

    },
});

export const { StoreFiltersFun, InwardAnalysisFun, InwardItemWiseSummFun, ItemVsSupplierFun, StoreStockAnalysisFun, PartyVsItemFun, IssueAnalysisFun, MachineGrpMonthlyConFun, FSNAnalysisFun, ItemWiseMachineWiseConFun, ABCAnalysisFun, MachineWiseConSummFun, MachineWiseGrpWiseConFun, MachineWiseConAnalysisFun } = MaintenanceSlice.actions;

export default MaintenanceSlice.reducer;

